import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <>
      <div>
        <footer class="footer">
          <div class="container bottom_border">
            <div class="row">
              <div class=" col-sm-4 col-md col-sm-4  col-12 col">
                <h5 class="headin5_amrc col_white_amrc pt2">Find us</h5>

                <p class="mb10">
                  The Tourism Authority of Thailand (TAT) has quarantine-free
                  reopening of Thailand to fully <br /> vaccinated foreign
                  visitors, including returning <br /> and foreign residents,
                  from the approved list
                </p>
                <p>
                  <i class="fa fa-location-arrow"></i> 9878/25 sec 9 rohini 35{" "}
                </p>
                <p>
                  <i class="fa fa-phone"></i> +91-9999878398{" "}
                </p>
                <p>
                  <i class="fa fa fa-envelope"></i> mehedihan@gmail.com{" "}
                </p>
              </div>

              <div class=" col-sm-4 col-md  col-6 col">
                <h5 class="headin5_amrc col_white_amrc pt2">Quick links</h5>

                <ul class="footer_ul_amrc">
                  <li>
                    <a href="http://webenlance.com">Image Rectoucing</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Clipping Path</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Hollow Man Montage</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Ebay & Amazon</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Hair Masking/Clipping</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Image Cropping</a>
                  </li>
                </ul>
              </div>

              <div class=" col-sm-4 col-md  col-6 col">
                <h5 class="headin5_amrc col_white_amrc pt2">Quick links</h5>

                <ul class="footer_ul_amrc">
                  <li>
                    <a href="http://webenlance.com">Remove Background</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">
                      Shadows & Mirror Reflection
                    </a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Logo Design</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Vectorization</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Hair Masking/Clipping</a>
                  </li>
                  <li>
                    <a href="http://webenlance.com">Image Cropping</a>
                  </li>
                </ul>
              </div>

              <div class=" col-sm-4 col-md  col-12 col">
                <h5 class="headin5_amrc col_white_amrc pt2">Follow us</h5>

                <ul class="footer_ul2_amrc">
                  <li>
                    <a href="#">
                      <i class="fab fa-twitter fleft padding-right"></i>{" "}
                    </a>
                    <p>
                      The Tourism Authority of Thailand (TAT) has confirmed ...
                      <a href="#">https://www.twitter.com/</a>
                    </p>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fab fa-facebook-f fleft padding-right"></i>{" "}
                    </a>
                    <p>
                      TravelDailyJobs.com online career platform hospitality ...
                      <a href="#">https://www.facebook.com/</a>
                    </p>
                  </li>
                  <li>
                    <a href="#">
                      <i class="fab fa-youtube fleft padding-right"></i>{" "}
                    </a>
                    <p>
                      Profile now discover travel and hospitality jobs
                      worldwide...
                      <a href="#">https://www.youtube.com/</a>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="container">
            <ul class="foote_bottom_ul_amrc">
              <li>
                <a href="http://webenlance.com">Home</a>
              </li>
              <li>
                <a href="http://webenlance.com">About</a>
              </li>
              <li>
                <a href="http://webenlance.com">Services</a>
              </li>
              <li>
                <a href="http://webenlance.com">Pricing</a>
              </li>
              <li>
                <a href="http://webenlance.com">Blog</a>
              </li>
              <li>
                <a href="http://webenlance.com">Contact</a>
              </li>
            </ul>

            <p class="text-center">
              Copyright @2021 | Designed With by <a href="#">Mehede Hasan</a>
            </p>

            <ul class="social_footer_ul">
              <li>
                <a href="http://webenlance.com">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="http://webenlance.com">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="http://webenlance.com">
                  <i class="fab fa-linkedin"></i>
                </a>
              </li>
              <li>
                <a href="http://webenlance.com">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
